// Это только для Organization

import EventAssociation from '@/models/list/event-association';
import { rServices } from '@/plugins/api';
import { indexedArray } from '@/utils/indexedArray';

export default {
  name: 'association',
  namespaced: true,
  state: {
    associations: {},
  },
  getters: {
    value: (state) => state.associations,
  },
  actions: {
    async getMyAssociations({ commit }, { params } = {}) {
      const { response } = await rServices.eventAssociations.getAll({ params: {
        ...params,
        'per-page': -1,
        expand: 'image,active_users_count,active_clubs_count,events_count,miniature,features,'
          + 'representative_offices_count,active_accreditation_organizers_count',
      } });
      const items = (response?.data?.data || []).map((i) => new EventAssociation(i, 'event-associations'));
      commit('SET_ASSOCIATIONS', items);
    },
  },
  mutations: {
    SET_ASSOCIATIONS(state, data = {}) {
      if (Array.isArray(data)) {
        state.associations = indexedArray(data, 'id');
      } else {
        state.associations = data || {};
      }
    },
    SET_ASSOCIATION(state, data = {}) {
      state.associations[data.id] = data || {};
    },
  },
};
